import CheckIcon from "@mui/icons-material/Check";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  ClickAwayListener,
  Grow,
  MenuItem,
  Paper,
  Popper,
  Tab,
} from "@mui/material";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { flushSync } from "react-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { USER_STATUS } from "../../../assets/data/common";
import PersonOutlineIcon16pxSvg from "../../../assets/images/icons/PersonOutlineIcon16pxSvg";
import QuestionIcon16pxSvg from "../../../assets/images/icons/QuestionIcon16pxSvg";
import RemoveUserIcon from "../../../assets/images/icons/RemoveUserIcon";
import avatar_2 from "../../../assets/images/logo/avatar-default-logo.png";
import {
  ControlpanelInfo2thButton,
  ControlpanelPrimaryButton,
  ControlpanelWarning2thButton,
  ControlpanelWarningButton,
} from "../../../components/StyledButton";
import { CustomAdvancedMenuList, CustomTabsV2 } from "../../../components/StyledComponents";
import BiometricOutlineIcon16pxSvg from "../../../assets/images/icons/BiometricOutlineIcon16pxSvg";
import CircleXIcon14pxSvg from "../../../assets/images/icons/CircleXIcon14pxSvg";
import DownloadIcon14pxSvg from "../../../assets/images/icons/DownloadIcon14pxSvg";
import EditIcon14pxSvg from "../../../assets/images/icons/EditIcon14pxSvg";
import HouseOutlineIcon16pxSvg from "../../../assets/images/icons/HouseOutlineIcon16pxSvg";
import IphoneFillIcon16oxSvg from "../../../assets/images/icons/IphoneFillIcon16oxSvg";
import IphoneOutlineIcon16pxSvg from "../../../assets/images/icons/IphoneOutlineIcon16pxSvg";
import MailOutlineIcon16pxSvg from "../../../assets/images/icons/MailOutlineIcon16pxSvg";
import PhoneOutlineIcon16pxSvg from "../../../assets/images/icons/PhoneOutlineIcon16pxSvg";
import ShowEventIcon14pxSvg from "../../../assets/images/icons/ShowEventIcon14pxSvg";
import SmileFaceIcon14pxSvg from "../../../assets/images/icons/SmileFaceIcon14pxSvg";
import StatusOutlineIcon16pxSvg from "../../../assets/images/icons/StatusOutlineIcon16pxSvg";
import UserGroupDoubleFillIcon16pxSvg from "../../../assets/images/icons/UserGroupDoubleFillIcon16pxSvg";
import DefaultTooltip from "../../../components/DefaultTooltip";
import AddNewEmployeeDialogForm from "./AddNewEmployeeDialogForm";
import BiometricDataDialog from "./BiometricDataDialog";
import ExportSelectUserDataDialog from "./ExportSelectUserDataDialog";
import RegisterDevicesDialog from "./RegisterDevicesDialog";
import RemoveUserDialog from "./RemoveUserDialog";
import StatusUserDialog from "./StatusUserDialog";
import UnregisterDeviceDialog from "./UnregisterDeviceDialog";
import RemoveUserSvg from "./../../../assets/images/icons/terminate.svg";
import { useAuth } from "../../../context/AuthContext";
import { LoadingProvider, useLoading } from "../../../context/LoadingContext";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EditNew20pxSvg from "../../../assets/images/icons/EditNew20pxSvg";
import { PropTypes } from 'prop-types';
import LeaveManagement from "./LeaveManagement";
import UserDetailTab from "./UserDetailTab";
import GroupManagement from "./GroupManagement";
import { getDetailByUser, getGroupByUserList } from "../../../axios/User/UserApi";
import { toast } from "react-toastify";
import { format } from "date-fns";
import DeviceManagement from "./DeviceManagement";

const UserInfoEmployeeRight = ({
  countries = [],
  userRoles,
  info,
  handleRefreshTable,
  openEditEmployee,
  setOpenEditEmployee,
  department,
  groupData,
  designation
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const language = useSelector((state) => state.languageR.language);
  const anchorRefStatus = useRef(null);
  const [openUnregisterDevice, setOpenUnregisterDevice] = useState(false);
  const [selectedDeviceName, setSelectedDeviceName] = useState({});
  const [openExportEmployee, setOpenExportEmployee] = useState(false);
  const [openRegisterDevices, setOpenRegisterDevices] = useState(false);
  const [statusMode, setStatusMode] = useState(USER_STATUS.none);
  const [openRemoveUser, setOpenRemoveUser] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [openBiometricData, setOpenBiometricData] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const { profile, genaralSettingDateFormat, isEmployee } = useAuth();
  const [show, hide] = useLoading()

  const [groupByUser, setGroupByUserData] = useState([]);
  const [detailUser, setDetailUser] = useState({})

  useEffect(() => {
    const fetchDetailUser = async () => {
      try {
        const response = await getDetailByUser({ id: profile?.userId });
        setDetailUser(response?.data?.data);
      } catch (err) {
        console.error("Error fetch device detail:", err);
      }
    };

    fetchDetailUser();
  }, [profile?.userId, isEmployee]);

  const fetchGroupByUserData = async () => {
    if (!info.userId) return;

    const payload = {
      langId: localStorage.getItem("i18nextLngId"),
      userId: info.userId,
    };

    show();

    try {
      const response = await getGroupByUserList(payload);
      if (
        response?.data?.message === "Successful" ||
        response?.data?.message === "Thành công"
      ) {
        setGroupByUserData(
          response.data.data
        );
      }
    } catch (error) {
      if (error?.response && error.response.status !== 401) {
        toast.error(error?.response?.data?.message || "Error");
      } else {
        toast.error(t('common.network-timeout'));
      }
    } finally {
      hide();
    }
  };

  useEffect(() => {
    fetchGroupByUserData();
  }, [info.userId]);

  const getCountryNameByAlpha3Code = useCallback(
    (alpha3Code) => {
      const country = countries.find(
        (country) => country.alpha3Code === alpha3Code
      );

      return country ? country.countryName : "content-144";
    },
    [countries]
  );

  const handleOpenBiometricData = () => {
    setOpenBiometricData(true);
  };

  const handleCloseBiometricData = () => {
    setOpenBiometricData(false);
  };

  const handleOpenRemoveUser = () => {
    setIsDelete(false);
    setOpenRemoveUser(true);
  };

  const handleOpenDeleteUser = () => {
    setIsDelete(true);
    setOpenRemoveUser(true);
  };

  const handleCloseRemoveUser = () => {
    setOpenRemoveUser(false);
  };

  const handleCloseStatusModal = () => {
    setStatusMode(USER_STATUS.none);
  };

  const handleCloseStatus = () => {
    setOpenStatus(false);
  };


  const handleOpenUnregisterDevice = (deviceName) => {
    setSelectedDeviceName(deviceName);
    setOpenUnregisterDevice(true);
  };

  const handleCloseUnregisterDevice = () => {
    setOpenUnregisterDevice(false);
  };

  const handleCloseEditEmployee = () => {
    setOpenEditEmployee(false);
  };

  const handleCloseExportEmployee = () => {
    setOpenExportEmployee(false);
  };

  const handleCloseRegisterDevices = () => {
    setOpenRegisterDevices(false);
  };

  const userType = [
    { value: 1, label: t("common.full-time") },
    { value: 2, label: t("common.part-time") },
  ];



  const getAdminRightLabel = (rights, t) => {
    const roleLabelMap = {
      EMPLOYEE: t("roles2.Employee"),
      AUDITOR: t("roles2.Auditor"),
      ADMIN: t("roles2.Admin"),
      SUBCRIPTION: t("roles2.SubscriptionAdmin"),
    };

    return (
      roleLabelMap[rights] ||
      (rights !== null && rights !== undefined && rights !== ""
        ? rights
        : t("common.not-provided"))
    );
  };

  const userData = isEmployee ? detailUser[0] : info;

  // Tìm nhãn tương ứng
  const userTypeLabel =
    userType.find((item) => item.value === userData?.userTypeId)?.label || "";

  const departmentName =
    department.find(
      (d) => d.departmentPrefix === userData?.employeeCode?.substring(0, 2)
    )?.departmentName || "";

  const isLoaded = Boolean(userData && userData?.userId);

  const dislayInfoData = useMemo(() => [
    {
      title: "common.personal-id",
      value: isLoaded ? userData?.personalID || "common.not-provided" : null,
      icon: <PersonOutlineIcon16pxSvg />,
    },
    {
      title: "common.email",
      value: isLoaded ? userData?.email || "common.not-provided" : null,
      icon: <MailOutlineIcon16pxSvg />,
    },
    {
      title: "common.employee-code",
      value: isLoaded ? userData?.employeeCode || "common.not-provided" : null,
      icon: <HouseOutlineIcon16pxSvg />,
    },
    {
      title: "common.admin",
      value: isLoaded
        ? getAdminRightLabel(userData?.administratorRights, t)
        : null,
      icon: <HouseOutlineIcon16pxSvg />,
    },
    {
      title: "common.status",
      value: isLoaded
        ? userData?.active === USER_STATUS.unblock
          ? "common.active"
          : userData?.active === USER_STATUS.terminate
            ? `${t("common.content-150")} ${format(
              new Date(userData?.terminateDate),
              genaralSettingDateFormat
            )}`
            : userData?.active === USER_STATUS.pendingActivation
              ? "common.pending-activation"
              : "common.blocked"
        : null,
      status: userData?.active,
      icon: <StatusOutlineIcon16pxSvg />,
    },
    {
      title: "common.user-type",
      value: isLoaded ? userTypeLabel || "common.not-provided" : null,
      icon: <HouseOutlineIcon16pxSvg />,
    },
    {
      title: "common.user-group",
      value: isLoaded ? (
        departmentName ? (
          <div className="inline-flex items-center justify-center bg-[#F3F4F6] px-2 py-[2px] text-[#374151] text-sm w-fit min-w-[40px] rounded-sm">
            {departmentName}
          </div>
        ) : (
          <p>{t("common.not-in-any-group")}</p>
        )
      ) : null,
      icon: <UserGroupDoubleFillIcon16pxSvg />,
    },
    {
      title: "common.phone",
      value: isLoaded ? userData.telephone || "common.not-provided" : null,
      icon: <PhoneOutlineIcon16pxSvg />,
    },
    {
      title: "common.address",
      value: isLoaded
        ? `${userData.address ? `${userData.address}, ` : ""}${userData.city ? `${userData.city}, ` : ""
          }${getCountryNameByAlpha3Code(userData.country)}`.trim()
        : null,
      icon: <HouseOutlineIcon16pxSvg />,
    },
    {
      title: "common.permanentAddress",
      value: isLoaded ? userData.permanentAddress || "common.not-provided" : null,
      icon: <HouseOutlineIcon16pxSvg />,
    },
    // {
    //   title: "common.joinedDate",
    //   value: isLoaded ? format(userData?.joinDate, genaralSettingDateFormat) || "common.not-provided" : null,
    //   icon: <BiometricOutlineIcon16pxSvg />,
    // },
  ], [isLoaded, userData, getCountryNameByAlpha3Code]);

  const [tabValue, setTabValue] = useState(0)

  // Tour employee: chuyển tab Devices / User groups / Leave
  useEffect(() => {
    window.__setEmployeeRightTab = (index) => {
      flushSync(() => setTabValue(index));
    };
    return () => {
      delete window.__setEmployeeRightTab;
    };
  }, []);

  const handleChangeTab = (event, newValue) => {
    if (!isLoaded) return;

    setTabValue(newValue);
  };

  const a11yProps = (index) => {
    return {
      id: `user-tab-${index}`,
      'aria-controls': `user-tabpanel-${index}`,
    };
  }

  const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`settings-${index}`}
        aria-labelledby={`settings-tab-${index}`}
        {...other}
      >
        {value === index && (
          <div className='mt-3'>
            {children}
          </div>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  return (
    <div className="card px-3 py-3">
      <div className="flex gap-3 items-center">
        <p className="text-xl font-semibold">
          {isLoaded ? userData.fullName : t("common.user-detail")}
        </p>

        {/* <DefaultTooltip
          readMore={true}
          title={t("tool-tip.user-quick-view")}
          content={
            <div className="flex flex-col gap-3">
              <p>
                {t(
                  "tool-tip.this-section-allow-to-control-all-user-specific-function"
                )}
              </p>
            </div>
          }
        >
          <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
        </DefaultTooltip>
        <p className="text-xl font-semibold">
          {language === "vi" ? userTypeLabel : userTypeLabel}
        </p> */}
      </div>
      <CustomTabsV2
        variant="fullWidth"
        indicatorColor="none"
        value={tabValue}
        onChange={handleChangeTab}
      >
        <Tab
          label={t('common.devices')}
          {...a11yProps(0)}
          disableRipple
          disabled={!isLoaded}
          data-tour="user-management-device-tab"
        />

        <Tab
          label={t('common.user-groups')}
          {...a11yProps(1)}
          disableRipple
          disabled={!isLoaded}
          data-tour="user-management-usergroup-tab"
        />

        <Tab
          label={t('common.leave')}
          {...a11yProps(2)}
          disableRipple
          disabled={!isLoaded}
          data-tour="user-management-leave-tab"
        />
      </CustomTabsV2>

      <CustomTabPanel value={tabValue} index={2}>
        <div data-tour="user-management-leave-panel">
          <LeaveManagement userId={info.userId} handleRefreshTable={handleRefreshTable} />
        </div>
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={1}>
        <div data-tour="user-management-usergroup-panel">
          <GroupManagement userId={info.userId} />
        </div>
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={0}>
        <div data-tour="user-management-device-panel">
          <LoadingProvider><DeviceManagement userId={info.userId} /></LoadingProvider>
        </div>
      </CustomTabPanel>
      <Popper
        open={openStatus}
        anchorEl={anchorRefStatus.current}
        placement="bottom-end"
        transition
        disablePortal
        className="z-50"
        container={anchorRefStatus.current?.parentElement}
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 8], // x, y
            },
          },
        ]}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "left top" : "left bottom",
            }}
          >
            <Paper style={{ borderRadius: "8px", marginTop: 3, padding: 8 }}>
              <ClickAwayListener onClickAway={handleCloseStatus}>
                <CustomAdvancedMenuList>
                  <MenuItem
                    className="gap-3 items-center h-9 hover:!bg-blue-100"
                    style={{
                      padding: "8px 12px",
                      borderRadius: 6,
                      pointerEvents: "auto",
                    }}
                    onClick={(e) => {
                      handleCloseStatus(e);
                      navigate("/controlpanel/event-log-management", {
                        state: { userId: info.userId },
                      })
                    }}
                  >
                    <p className="w-4 h-4 content-center">
                      <ShowEventIcon14pxSvg className="m-auto" />
                    </p>
                    <p>{t("button.show-event")}</p>
                  </MenuItem>
                  <MenuItem
                    className="gap-3 items-center h-9 hover:!bg-blue-100"
                    style={{
                      padding: "8px 12px",
                      borderRadius: 6,
                      opacity: "0.5",
                      pointerEvents: "none",
                    }}
                    onClick={(e) => {
                      handleCloseStatus(e);
                      handleOpenBiometricData();
                    }}
                  >
                    <p className="w-4 h-4 content-center">
                      <SmileFaceIcon14pxSvg className="m-auto" />
                    </p>
                    <p>{t("button.biometric")}</p>
                  </MenuItem>

                  {(info.active === USER_STATUS.unblock ||
                    info.active === USER_STATUS.terminate) && (
                      <MenuItem
                        className="gap-3 items-center h-9 hover:!bg-blue-100"
                        style={{
                          padding: "8px 12px",
                          borderRadius: 6,
                          opacity: "0.5",
                          pointerEvents: "none",
                        }}
                        onClick={(e) => {
                          handleCloseStatus(e);
                          setStatusMode(USER_STATUS.block);
                        }}
                      >
                        <p className="w-4 h-4 content-center">
                          <CircleXIcon14pxSvg className="m-auto w-full" />
                        </p>
                        <p>{t("button.block")}</p>
                      </MenuItem>
                    )}

                  {(info.active === USER_STATUS.block ||
                    info.active === USER_STATUS.terminate) && (
                      <MenuItem
                        className="gap-3 items-center h-9 hover:!bg-blue-100"
                        style={{ padding: "8px 12px", borderRadius: 6 }}
                        onClick={(e) => {
                          handleCloseStatus(e);
                          setStatusMode(USER_STATUS.unblock);
                        }}
                      >
                        <p className="w-4 h-4 grid">
                          <CheckIcon fontSize="14" className="m-auto w-full" />
                        </p>
                        <p>{t("button.active")}</p>
                      </MenuItem>
                    )}

                  {info.active !== USER_STATUS.terminate &&
                    info.active !== USER_STATUS.pendingActivation && (
                    <MenuItem
                      disabled={info?.owner === true}
                      className="gap-3 items-center h-9 hover:!bg-blue-100"
                      style={{ padding: "8px 12px", borderRadius: 6 }}
                      onClick={(e) => {
                        handleCloseStatus(e);
                        setStatusMode(USER_STATUS.terminate);
                      }}
                    >
                      <p className="w-4 h-4 grid">
                        <img
                          src={RemoveUserSvg}
                          alt="Remove User"
                          className="m-auto w-full"
                        />
                      </p>
                      <p>{t("common.content-150")}</p>
                    </MenuItem>
                  )}

                  <MenuItem
                    className="gap-3 items-center h-9 hover:!bg-blue-100"
                    style={{
                      padding: "8px 12px",
                      borderRadius: 6,
                      opacity: "0.5",
                      pointerEvents: "none",
                    }}
                    onClick={(e) => {
                      handleCloseStatus(e);
                      setOpenExportEmployee(true);
                    }}
                  >
                    <p className="w-4 h-4 grid">
                      <DownloadIcon14pxSvg
                        fontSize="16"
                        className="m-auto w-full"
                      />
                    </p>
                    <p>{t("button.export")}</p>
                  </MenuItem>

                  <MenuItem
                    disabled={info?.owner === true}
                    className="gap-3 items-center h-9 !text-red-500 hover:!bg-blue-100 disabled:opacity-50 disabled:pointer-events-none disabled:cursor-not-allowed"
                    style={{ padding: "8px 12px" }}
                    onClick={(e) => {
                      if (info?.owner) return; // đảm bảo không gọi khi bị disable
                      handleCloseStatus(e);
                      handleOpenRemoveUser();
                    }}
                  >
                    <p className="w-4 h-4 grid">
                      <RemoveUserIcon fontSize="16" className="m-auto w-full" />
                    </p>
                    <p>{t("button.remove")}</p>
                  </MenuItem>
                </CustomAdvancedMenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      {openBiometricData && (
        <BiometricDataDialog
          firstName={info.firstName}
          lastName={info.lastName}
          userGroup={info.userGroup}
          onClose={handleCloseBiometricData}
        />
      )}
      {openRemoveUser && (
        <RemoveUserDialog
          isDelete={isDelete}
          info={info}
          onRefresh={handleRefreshTable}
          onClose={handleCloseRemoveUser}
        />
      )}
      {statusMode !== USER_STATUS.none && (
        <StatusUserDialog
          mode={statusMode}
          info={info}
          onRefresh={handleRefreshTable}
          onClose={handleCloseStatusModal}
        />
      )}
      {openUnregisterDevice && (
        <UnregisterDeviceDialog
          selectedDeviceName={selectedDeviceName}
          onClose={handleCloseUnregisterDevice}
        />
      )}
      {openExportEmployee && (
        <ExportSelectUserDataDialog
          info={info}
          onClose={handleCloseExportEmployee}
        />
      )}
      {openRegisterDevices && (
        <RegisterDevicesDialog
          info={info}
          onClose={handleCloseRegisterDevices}
        />
      )}
      {openEditEmployee && (
        <LoadingProvider>
          <AddNewEmployeeDialogForm
            isEdit
            defaultValue={info}
            userRoles={userRoles}
            countries={countries}
            handleRefreshTable={handleRefreshTable}
            onClose={handleCloseEditEmployee}
            department={department}
            groupData={groupData}
            groupByUser={groupByUser}
            designation={designation}
          />
        </LoadingProvider>
      )}
    </div>
  );
};

export default UserInfoEmployeeRight;
